import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const HP_MIXED_GRID_MVP_TEST_NAME = 'HP_MixedGridMVP_July2026';

export const trackHpMixedGridMvpTest = (): void => {
    trackAbTestV2Variant(HP_MIXED_GRID_MVP_TEST_NAME);
};
